import type { InvokeDefinition, StreamDefinition } from '../../signalr/types'
import { createOrderFromResponse } from '../order/helpers'
import type { OrderResponse } from '../order/types'
import {
  type ForceCancelAction,
  type MarkAsRestrictedAction,
  type MarkAsUnrestrictedAction,
  type SubscribeDepthForSecurityAction,
  type UnsubscribeDepthForSecurityAction,
  forceCancelFailure,
  forceCancelSuccess,
  markAsRestrictedFailure,
  markAsRestrictedSuccess,
  markAsUnrestrictedFailure,
  markAsUnrestrictedSuccess,
  setDepthForSecurity,
  setDepthForSecurityFailed
} from './actions'

export const subscribeDepthForSecurityDefinition: StreamDefinition<
  [number, number],
  OrderResponse[],
  SubscribeDepthForSecurityAction
> = {
  method: 'GetDepthForSecurity',
  strategy: 'merge',
  getParams: (_state, action) => [
    action.payload.securityId,
    action.payload.quoteReliability
  ],
  mapResponse: (orderResponses, action) =>
    setDepthForSecurity(
      action.payload.securityId,
      orderResponses.map((o) => createOrderFromResponse(o)),
      action.payload.callId
    ),
  mapError: (_err, action) =>
    setDepthForSecurityFailed(action.payload.securityId, action.payload.callId),
  cancelOn: ['depthofmarket.unsubscribeDepthForSecurity'],
  cancelFilter: (
    cancelAction: UnsubscribeDepthForSecurityAction,
    triggerAction
  ) =>
    cancelAction.payload.securityId === triggerAction.payload.securityId &&
    cancelAction.payload.callId === triggerAction.payload.callId
}

export const markAsRestrictedDefinition: InvokeDefinition<
  [string],
  any,
  MarkAsRestrictedAction
> = {
  method: 'MarkAsRestricted',
  getParams: (_state, action) => [action.payload.id],
  mapResponse: markAsRestrictedSuccess,
  mapError: markAsRestrictedFailure
}

export const markAsUnrestrictedDefinition: InvokeDefinition<
  [string],
  any,
  MarkAsUnrestrictedAction
> = {
  method: 'MarkAsUnrestricted',
  getParams: (_state, action) => [action.payload.id],
  mapResponse: markAsUnrestrictedSuccess,
  mapError: markAsUnrestrictedFailure
}

export const forceCancelDefinition: InvokeDefinition<
  [string],
  any,
  ForceCancelAction
> = {
  method: 'ForceCancel',
  getParams: (_state, action) => [action.payload.id],
  mapResponse: forceCancelSuccess,
  mapError: forceCancelFailure
}
